export default {"src":"/_next/static/media/open-zeppelin-icon.c6938a30.svg","height":40,"width":36,"blurWidth":0,"blurHeight":0};